// extracted by mini-css-extract-plugin
export default {"Notifications":"Notifications_Notifications__OnyOr","Notifications__new":"Notifications_Notifications__new__cqZUp","Notifications__table":"Notifications_Notifications__table__hsv6b"};